import React, { Component } from "react";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as proActions from "../actions/profiles-actions";
import {Helmet} from "react-helmet";
class Pager extends Component {

  getProfiles(page) {
    let query = "";
    if(this.props.WebPage.Page.Settings.ProfilesQuery) {
      query = this.props.WebPage.Page.Settings.ProfilesQuery.replace(",","%2C");
    }
    this.props.dispatch(proActions.getProfiles(page,10, query));
  }

  changePage(evt,pge) {
    if (window) { window.$("HTML").animate({ scrollTop: 120 }, 500); }
    //evt.preventDefault();
    //this.getProfiles(pge);
  }

  removeParameterFromUrl(url, parameter) {
    return url
      .replace(new RegExp('[?&]' + parameter + '=[^&#]*(#.*)?$'), '$1')
      .replace(new RegExp('([?&])' + parameter + '=[^&]*&'), '$1');
  }

  getPageLocation(pge) {
    let currentLoc = "";
    if(typeof document === "undefined") {
      currentLoc = this.props.WebPage.ServerParams.Path + this.props.WebPage.ServerParams.Query;
    } else {
      currentLoc = document.location.pathname + document.location.search;
    }
    let nLoc = this.removeParameterFromUrl(currentLoc, "page");    
    if(nLoc.indexOf("?")<=-1) {
      nLoc += "?page=" + pge;
    } else {
      nLoc += "&page=" + pge;
    }
    return nLoc;
  }



  render() {
    let hasNext = true;
    let hasLast = true;

    let pges = [];
    let NextPage = parseInt(this.props.Page, 10)+1;
    let LastPage = parseInt(this.props.Page, 10)-1;
    if(NextPage > this.props.TotalPages) {hasNext = false; NextPage = 1; }
    if(LastPage <=0 ) { hasLast = false; LastPage = this.props.TotalPages; }
    let StartPage = this.props.Page;
    if(this.props.TotalPages - this.props.ShowPages < StartPage) {
      StartPage = this.props.TotalPages - this.props.ShowPages;
    }
    if(StartPage <= 0) { StartPage = 1; }
    let EndPage = StartPage + this.props.ShowPages;
    if(EndPage > this.props.TotalPages) {
      EndPage = this.props.TotalPages;
    }
    for(let x=StartPage; x<=EndPage; x++) {
      let pge = <Link to={this.getPageLocation(x)} key={"pager"+x} onClick={(e)=>this.changePage(e,x)} title={"Page " + x}>{x}</Link>;
      if(x===this.props.Page) {
        pge = <a key={"pager"+x} className="active" title={"Page " + x}>{x}</a>;
      }
      pges.push(pge);
    }

    return (
      <div className="pagination centered-content" style={{ clear: "both",display: "flex", justifyContent: "center" }}>
        <Helmet>
          {hasLast &&
          <link rel="prev" href={this.getPageLocation(LastPage)} />
          }
          {hasNext &&
          <link rel="next" href={this.getPageLocation(NextPage)} />
          }

        </Helmet>
        {hasLast &&
        <Link rel={"prev"} to={this.getPageLocation(LastPage)} key={"last"+LastPage} onClick={(e)=>this.changePage(e,LastPage)} title={"Page " + LastPage}><i className="fa fa-arrow-circle-left"></i></Link>
        }
        {pges}
        {hasNext &&
        <Link rel={"next"} to={this.getPageLocation(NextPage)} key={"next"+NextPage} onClick={(e)=>this.changePage(e,NextPage)} title={"Page " + NextPage}><i className="fa fa-arrow-circle-right"></i></Link>
        }
      </div>
    );
  }


/*<a href="#" title="">1</a>
<a href="#" className="active" title="">2</a>
<a href="#" title="">3</a>
*/

}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website
  };
}

export default connect(mapStateToProps)(Pager);
